import { TRANSACTION_DIRECTIONS } from "../utilities/vanilla/vanillaData";
import { TransactionDirection } from "../utilities/vanilla/vanillaEnums";

const REASON_INSTRUMENT = "Selling this product is not currently allowed.";
const REASON_PERMISSIONS = "This company is not approved for selling.";

const useTransactionDirections = (canCompanySell: boolean, isSellable: boolean) => {
  const transactionDirections = TRANSACTION_DIRECTIONS.map(({ text, value }) => {
    const isEnabled = value === TransactionDirection.Long || (canCompanySell && isSellable);
    const chipItem = { text, value, disabled: !isEnabled };
    return chipItem;
  });

  const tooltip = !isSellable ? REASON_INSTRUMENT : !canCompanySell ? REASON_PERMISSIONS : "";

  return {
    data: transactionDirections,
    tooltip,
  };
};

export default useTransactionDirections;
